import Nav from '../../Global/Nav.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

var _EditorOption_ = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ size: [12, 14, 16] }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['clean'],
      ['link', 'image', 'video']
    ]
  },
  placeholder: '请输入正文'
};
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
];
export default {
  name: 'Customers',
  components: {
    Nav,
    quillEditor
  },
  data() {
    return {
      editorOption: _EditorOption_,
      activeName: 'customers',
      keywords: '',
      vLoading: false,
      customersList: [],
      customersTotal: 0,
      current_page: 1,
      size: 10,
      addCustomerVisible: false,
      addCustomerLoading: false,
      levelsOption: [],
      countriesOption: [],
      citiesOption: [],
      platformOption: [],
      addCustomerForm: {
        company: null,
        company_site: null,
        contactor: null,
        level: null,
        nation_id: null,
        area_id: null,
        email: null,
        telephone: null,
        fax: null,
        other_contact_way: null,
        remarks: null,
        platform: null
      },
      addCustomerRules: {
        contactor: [
          { required: true, message: '联系人不能为空', trigger: 'commit' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'commit' }
        ]
      },
      editCustomerTitle: '',
      editCustomerVisible: false,
      editCustomerLoading: false,
      editCustomerForm: {
        company: null,
        company_site: null,
        contactor: null,
        level: null,
        nation_id: null,
        area_id: null,
        email: null,
        telephone: null,
        fax: null,
        other_contact_way: null,
        remarks: null,
        platform: null
      },
      addCustomerTimelineTitle: '',
      addCustomerTimelineVisible: false,
      addCustomerTimelineForm: {
        customer_id: '',
        follow_at: '',
        feedback: '',
        remarks: '',
        follow_by: this.$userinfo.id
      },
      addCustomerTimelineRules: {
        follow_at: [
          { required: true, message: '此项必填', trigger: 'commit' }
        ],
        feedback: [
          { required: true, message: '此项必填', trigger: 'commit' }
        ]
      },
      users: [],
      timelineDialogTitle: '',
      timelineDialogVisible: false,
      timelineDialogLoading: false,
      reverse: true,
      timelines: [],
      emailDetailVisible: false,
      emailDetail: {},
      emailDetailLoading: false,
      followLettersKeywords: '',
      followLettersList: [],
      followLettersTotal: 0,
      followLettersSize: 10,
      followLettersPage: 1,
      addAutoFollowLettersLoading: false,
      addAutoFollowLettersVisible: false,
      addAutoFollowLettersForm: {
        title: '',
        content: ''
      },
      addAutoFollowLettersRules: {
        content: [
          { required: true, message: '正文不能为空', trigger: 'commit' }
        ]
      },
      editAutoFollowLettersLoading: false,
      editAutoFollowLettersVisible: false,
      editAutoFollowLettersForm: {
        title: '',
        content: ''
      },
      editAutoFollowLettersRules: {
        content: [
          { required: true, message: '正文不能为空', trigger: 'commit' }
        ]
      },
      followCustomersVisible: false,
      followCustomersLoading: false,
      followCustomersForm: {
        customer_id: '',
        customer_name: '',
        follow_period: 7,
        follow_mode: '1',
        in_auto_followed: true
      },
      followCustomersRules: {
        follow_letter_id: [
          { required: true, message: '不能为空', trigger: 'commit' }
        ]
      },
      follow_letters: [],
      follow_mode_options: [
        {
          label: '回复为止',
          value: '1'
        },
        {
          label: '指定日期',
          value: '2'
        }
      ],
      followEndTimeVisable: false,
      recycleBinList: [],
      recycleBinTotal: 0,
      recycleBinCurrentPage: 1,
      recycleBinSize: 10,
      recycleBinCustomerTitle: '',
      recycleBinCustomerVisible: false,
      recycleBinCustomer: {},
      queryPlatform: null,
      annotationsList: [],
      annotationsTitle: '',
      annotationsVisible: false,
      annotationsForm: {
        customer_id: '',
        content: ''
      },
      annotationsRules: {
        content: [
          { required: true, message: '内容不能为空', trigger: 'commit' }
        ]
      }
    }
  },
  mounted() {
    this.getPlatforms();
    setTimeout(() => {
      this.current_page = 1;
      this.queryCustomersList();
    }, 0)
    // this.intervals = setInterval(() => {
    //   if (this.activeName == 'worldmap') {
    //     this.worldMap();
    //   }
    // }, 30000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'customers':
          this.queryCustomersList();
          break;
        case 'follow_letter':
          this.queryFollowLettersList();
          break;
        case 'recycle_bin':
          this.queryRecycleBinList();
          break;
        case 'worldmap':
          this.worldMap();
          break;
      }
    },
    worldMap() {
      this.$axios.get('/customers/master/map').then((response) => {
        var geoCoordMap = response.data.data.geoCoordMap
        var BJData = response.data.data.BJData
        let myChart = this.$echarts.init(document.getElementById("main"));
        var series = [];
        [[, BJData]].forEach(function (item, i) {
          series.push({
            type: 'effectScatter',
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              // 涟漪特效
              period: 4, // 动画时间，值越小速度越快
              brushType: 'stroke', // 波纹绘制方式 stroke, fill
              scale: 10
              // 波纹圆环最大限制，值越大波纹越大
            },
            label: {
              normal: {
                show: true,
                position: 'right', // 显示位置
                offset: [5, 0], // 偏移设置
                formatter: "{b}" // 圆环显示文字
              },
              emphasis: {
                show: true
              }
            },
            symbol: "circle",
            symbolSize: function (val) {
              var level = 0;
              var state = Math.floor(val[2] / 5000);
              level = (state >= 0 && state <= 9) ? state : 10;
              return 5 + level; // 圆环大小
            },
            data: item[1].map(function (dataItem) {
              return {
                name: dataItem.name,
                value: geoCoordMap[dataItem.name]
                  .concat([dataItem.value])
              };
            })
          });
        });

        let option = {
          backgroundColor: '#000',
          // 悬浮提示
          tooltip: {
            trigger: "item",
            backgroundColor: "#FFF",
            borderColor: "#FFFFCC",
            showDelay: 0,
            hideDelay: 0,
            // enterable: true,
            transitionDuration: 0,
            // extraCssText: "z-index:100",formatter
            formatter: function (params, ticket, callback) {
              var res = "";
              var value = params.value[params.seriesIndex + 2];
              res = "Customers: " + value;
              return res;
            }
          },
          visualMap: {
            // 图例值控制
            min: 0,
            max: 10000,
            text: ['High', 'Low'],
            show: false,
            calculable: true,
            color: ["#0BC7FF"]
          },
          geo: {
            map: "world",
            label: {
              emphasis: {
                show: false
              }
            },
            roam: true, // 是否允许缩放
            layoutCenter: ["50%", "50%"], // 地图位置
            layoutSize: "180%",
            itemStyle: {
              normal: {
                color: ["#FFF"], // 地图背景色
                borderColor: "#5bc1c9" // 省市边界线
              },
              emphasis: {
                color: "rgba(37, 43, 61, .5)" // 悬浮背景
              }
            }
          },
          series: series
        };
        myChart.setOption(option);
      })
    },
    async getPlatforms() {
      await this.$axios.get('/customers/master/platforms').then((response) => {
        this.platformOption = response.data.data;
      });
    },
    queryCustomersList() {
      this.vLoading = true;
      let current_page = this.current_page;
      let keywords = this.keywords;
      let size = this.size;
      let platform = this.queryPlatform;
      this.$axios.get('/customers/master/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size,
          platform: platform
        }
      }).then((response) => {
        this.vLoading = false
        if (response.data.code === 200) {
          this.customersList = response.data.data.data;
          this.customersTotal = response.data.data.total;
        }
      })
    },
    changeCustomersSize(val) {
      this.size = val;
      this.queryCustomersList();
    },
    currentCustomersChange(val) {
      this.current_page = val;
      this.queryCustomersList();
    },
    async addCustomer() {
      this.addCustomerVisible = true;
      this.addCustomerLoading = true;
      await this.$axios.get('/customers/master/options').then((response) => {
        this.levelsOption = response.data.data.levels;
        this.countriesOption = response.data.data.world_cities;
      });
      this.addCustomerLoading = false;
    },
    cancelAddCustomer() {
      this.addCustomerVisible = false;
      this.addCustomerForm = {
        company: '',
        company_site: '',
        contactor: '',
        level: '',
        nation_id: '',
        area_id: '',
        email: '',
        telephone: '',
        fax: '',
        other_contact_way: '',
        remarks: ''
      }
    },
    async confirmAddCustomer() {
      this.$refs.addCustomerForm.validate(valid => {
        if (valid) {
          this.addCustomerLoading = true;
          this.$axios.post('/customers/master/add',
            this.addCustomerForm
          ).then((response) => {
            this.queryCustomersList();
            this.addCustomerVisible = false;
            this.addCustomerLoading = false;
          }).catch(function (error) {
            this.addCustomerLoading = false;
          })
          this.addCustomerForm = {
            company: '',
            company_site: '',
            contactor: '',
            level: '',
            nation_id: '',
            area_id: '',
            email: '',
            telephone: '',
            fax: '',
            other_contact_way: '',
            remarks: ''
          }
        }
      })
    },
    async getCities(v, type) {
      if (type === 'add') {
        this.addCustomerLoading = true;
      } else if (type === 'edit') {
        this.editCustomerLoading = true;
      }
      this.addCustomerForm.area_id = '';
      this.citiesOption = [];
      await this.$axios.get('/basic/world_city_list', {
        params: {
          parent_id: v
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.citiesOption = response.data.data;
          this.addCustomerLoading = false;
          this.editCustomerLoading = false;
        }
      });
    },
    async editCustomers(row) {
      this.editCustomerVisible = true;
      this.editCustomerLoading = true;
      await this.$axios.get('/customers/master/options').then((response) => {
        if (response.data.code === 200) {
          this.levelsOption = response.data.data.levels;
          this.countriesOption = response.data.data.world_cities;
        }
      });
      let id = row.id;
      await this.$axios.get(`/customers/master/detail`, {
        params: {
          id: id
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.editCustomerForm = response.data.data;
          this.editCustomerTitle = response.data.data.contactor
          setTimeout(() => {
            this.getCities(response.data.data.nation_id)
          })
        }
      });
      this.editCustomerLoading = false;
    },
    cancelEditCustomer() {
      this.editCustomerVisible = false;
      this.editCustomerForm = {
        company: '',
        company_site: '',
        contactor: '',
        level: '',
        nation_id: '',
        area_id: '',
        email: '',
        telephone: '',
        fax: '',
        other_contact_way: '',
        remarks: ''
      }
    },
    async confirmEditCustomer() {
      this.$refs.editCustomerForm.validate(valid => {
        if (valid) {
          this.editCustomerLoading = true;
          this.$axios.post('/customers/master/edit',
            this.editCustomerForm
          ).then((response) => {
            this.queryCustomersList();
            this.editCustomerVisible = false;
            this.editCustomerLoading = false;
          }).catch(function (error) {
            this.editCustomerLoading = false;
          })
          this.editCustomerForm = {
            company: '',
            company_site: '',
            contactor: '',
            level: '',
            nation_id: '',
            area_id: '',
            email: '',
            telephone: '',
            fax: '',
            other_contact_way: '',
            remarks: ''
          }
        }
      })
    },
    async addCustomerTimeline(customer_id, contactor) {
      this.addCustomerTimelineVisible = true;
      this.addCustomerTimelineTitle = "添加" + contactor + "的跟进记录";
      this.addCustomerTimelineForm.customer_id = customer_id
      await this.$axios.get(`/basic/users/list`).then((response) => {
        if (response.data.code === 200) {
          this.users = response.data.data
        }
      })
    },
    cancelAddCustomerTimeline() {
      this.addCustomerTimelineVisible = false;
      this.addCustomerTimelineForm = {
        customer_id: '',
        follow_at: '',
        feedback: '',
        remarks: '',
        follow_by: this.$userinfo.id
      }
    },
    confirmAddCustomerTimeline() {
      this.$refs.addCustomerTimelineForm.validate(valid => {
        if (valid) {
          this.$axios.post('/customers/master/record',
            this.addCustomerTimelineForm
          ).then((response) => {
            this.$notify({
              title: 'success',
              message: '添加成功',
              type: 'success'
            })
            this.queryCustomersList();
            this.addCustomerTimelineVisible = false;
          }).catch(function (error) {

          })
          this.addCustomerTimelineForm = {
            customer_id: '',
            follow_at: '',
            feedback: '',
            remarks: '',
            follow_by: this.$userinfo.id
          };
        }
      })
    },
    async showCustomerTimeline(customer_id, contactor) {
      this.timelineDialogVisible = true;
      this.timelineDialogTitle = contactor + "的联系记录";
      this.timelineDialogLoading = true;
      await this.$axios.get(`/customers/master/timeline?customer_id=` + customer_id).then((response) => {
        this.timelineDialogLoading = false;
        if (response.data.code === 200) {
          this.timelines = response.data.data
        }
      })
    },
    async showEmailContent(message_id) {
      this.emailDetail = {};
      this.emailDetailLoading = true;
      this.emailDetailVisible = true;
      await this.$axios.get(`mailer/email/detail?message_id=` + message_id + `&seen=1`)
        .then((response) => {
          if (response.data.code === 200) {
            this.emailDetail = response.data.data
          } else {
            this.$notify({
              title: 'Error',
              message: response.data.data,
              type: 'error'
            })
          }
          this.emailDetailLoading = false;
        });
    },
    showUploadContractDocs() { },
    addFollowLetter() {
      this.addAutoFollowLettersVisible = true
    },
    cancelAddAutoFollowLetters() {
      this.addAutoFollowLettersVisible = false;
      this.addAutoFollowLettersForm = {
        title: '',
        content: ''
      }
    },
    async confirmAddAutoFollowLetters() {
      this.$refs.addAutoFollowLettersForm.validate(valid => {
        if (valid) {
          this.addAutoFollowLettersLoading = true;
          this.$axios.post('/customers/follow_letters/add',
            this.addAutoFollowLettersForm
          ).then(() => {
            this.queryFollowLettersList();
            this.addAutoFollowLettersVisible = false;
            this.addAutoFollowLettersLoading = false;
          }).catch(function () {
            this.addAutoFollowLettersLoading = false;
          })
          this.addAutoFollowLettersForm = {
            title: '',
            content: ''
          }
        }
      })
    },
    editFollowLetter(row) {
      this.editAutoFollowLettersVisible = true;
      this.editAutoFollowLettersLoading = true;
      this.$axios.get(`/customers/follow_letters/detail?id=${row.id}`).then((response) => {
        this.editAutoFollowLettersLoading = false;
        if (response.data.code === 200) {
          this.editAutoFollowLettersForm = response.data.data;
        } else {
          this.$notify({
            title: 'failed',
            message: response.data.data,
            type: 'warning'
          })
        }
      })
    },
    cancelEditAutoFollowLetters() {
      this.editAutoFollowLettersVisible = false;
      this.editAutoFollowLettersForm = {
        title: '',
        content: ''
      }
    },
    async confirmEditAutoFollowLetters() {
      this.$refs.editAutoFollowLettersForm.validate(valid => {
        if (valid) {
          this.editAutoFollowLettersLoading = true;
          this.$axios.post('/customers/follow_letters/save',
            this.editAutoFollowLettersForm
          ).then((response) => {
            this.editAutoFollowLettersLoading = false;
            if (response.data.code === 200) {
              if (response.data.data.code === 1) {
                this.queryFollowLettersList();
                this.editAutoFollowLettersVisible = false;
              } else if (response.data.data.code === 2) {
                this.$confirm("此信正在用于客户\n[ " + response.data.data.data + " ]\n的自动跟踪, 确定保存吗", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$axios.post('/customers/follow_letters/real_save',
                    this.editAutoFollowLettersForm
                  ).then((response) => {
                    if (response.data.code === 200) {
                      this.queryFollowLettersList();
                      this.editAutoFollowLettersVisible = false;
                    }
                  })
                })
              }
            }
          }).catch(function () {
            this.editAutoFollowLettersLoading = false;
          })
          // this.editAutoFollowLettersForm = {
          //   title: '',
          //   content: ''
          // }
        }
      })
    },
    queryFollowLettersList() {
      this.vLoading = true;
      let current_page = this.followLettersPage;
      let keywords = this.followLettersKeywords;
      let size = this.followLettersSize;
      this.$axios.get('/customers/follow_letters/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.vLoading = false
        if (response.data.code === 200) {
          this.followLettersList = response.data.data.data;
          this.followLettersTotal = response.data.data.total;
        }
      })
    },
    changeFollowLettersSize(val) {
      this.followLettersSize = val;
      this.queryFollowLettersList();
    },
    currentFollowLettersChange(val) {
      this.followLettersPage = val;
      this.queryFollowLettersList();
    },
    followCustomers(row) {
      this.followCustomersVisible = true;
      this.followCustomersLoading = true;
      this.followCustomersForm = {
        customer_id: row.id,
        customer_name: row.contactor,
        follow_period: row.follow_period || 7,
        follow_mode: row.follow_mode || '1',
        end_time: row.follow_end_date,
        follow_letter_id: row.follow_letter_id,
        in_auto_followed: row.in_auto_followed
      }
      if (row.follow_mode === "2") {
        this.followEndTimeVisable = true;
      } else {
        this.followEndTimeVisable = false;
      }
      this.$axios.get(`/customers/follow_letters/options`).then((response) => {
        this.followCustomersLoading = false;
        if (response.data.code === 200) {
          this.follow_letters = response.data.data;
        }
      })
    },
    toggleFollowEndTime() {
      if (this.followCustomersForm.follow_mode === '2') {
        this.followEndTimeVisable = true
      } else {
        this.followEndTimeVisable = false
      }
    },
    cancelFollowCustomers() {
      this.followCustomersVisible = false;
      this.followCustomersLoading = false;
      this.followEndTimeVisable = false;
      this.followCustomersForm = {
        customer_id: '',
        customer_name: '',
        follow_period: 7,
        follow_mode: '1',
        in_auto_followed: true,
        end_time: null,
        follow_letter_id: ''
      }
    },
    confirmFollowCustomers() {
      this.$refs.followCustomersForm.validate(valid => {
        if (valid) {
          this.followCustomersLoading = true;
          this.$axios.post(`/customers/master/follow`,
            this.followCustomersForm
          ).then((response) => {
            this.followCustomersLoading = false;
            if (response.data.code === 200) {
              this.followCustomersVisible = false;
              this.queryCustomersList();
            }
          })
        }
      })
    },
    deleteFollowLetter(row) {
      this.$confirm("确定删除吗", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/customers/follow_letters/delete',
          {
            id: row.id
          }
        ).then((response) => {
          if (response.data.code === 200) {
            this.queryFollowLettersList();
          }
        })
      })
    },
    notCustomer(id) {
      this.$confirm("确定移除吗", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/customers/master/delete',
          {
            id: id
          }
        ).then((response) => {
          if (response.data.code === 200) {
            this.editCustomerVisible = false;
            this.queryCustomersList();
          }
        })
      })
    },
    changeRecycleBinSize(val) {
      this.recycleBinSize = val;
      this.queryRecycleBinList();
    },
    currentRecycleBinChange(val) {
      this.recycleBinCurrentPage = val;
      this.queryRecycleBinList();
    },
    queryRecycleBinList() {
      this.vLoading = true;
      let current_page = this.recycleBinCurrentPage;
      let size = this.recycleBinSize;
      this.$axios.get('/customers/master/recycle_bin', {
        params: {
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.vLoading = false
        if (response.data.code === 200) {
          this.recycleBinList = response.data.data.data;
          this.recycleBinTotal = response.data.data.total;
        }
      })
    },
    async viewRecycleBinCustomers(row) {
      this.recycleBinCustomer = {};
      this.recycleBinCustomerVisible = true;
      await this.$axios.get('/customers/master/options').then((response) => {
        if (response.data.code === 200) {
          this.levelsOption = response.data.data.levels;
          this.countriesOption = response.data.data.world_cities;
        }
      });
      let id = row.id;
      await this.$axios.get(`/customers/master/detail`, {
        params: {
          id: id
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.recycleBinCustomer = response.data.data;
          this.recycleBinCustomerTitle = response.data.data.contactor
          setTimeout(() => {
            this.getCities(response.data.data.nation_id)
          })
        }
      });
    },
    restoreRecycleBinCustomers(row) {
      this.$confirm("确定还原吗", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/customers/master/restore',
          {
            id: row.id
          }
        ).then((response) => {
          if (response.data.code === 200) {
            this.queryRecycleBinList();
          }
        })
      })
    },
    annotations(id, contactor) {
      this.annotationsTitle = contactor + '的批注';
      this.annotationsForm = {
        customer_id: id,
        content: ''
      }
      this.$axios.get(`/customers/master/annotaions?customer_id=${id}`).then((response) => {
        this.annotationsList = response.data.data
      });
      this.annotationsVisible = true;
    },
    cancelAnnotationsForm() {
      this.annotationsVisible = false;
    },
    submitAnnotationsForm() {
      this.$refs.annotationsForm.validate(valid => {
        if (valid) {
          this.$axios.post(`/customers/master/annotation_add`,
            this.annotationsForm
          ).then(() => {
            this.annotationsVisible = false;
          })
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Customers/script.js